module.exports = __webpack_public_path__ + "img/9791187312017.36fe76cc.jpg";